import { api_url } from "../../../utils";

const Aeropuerto = {
    enable: true,
    checked: false,
    initialDisplay: false,
    excludeCities: [],
    source: "api",
    url: api_url + "maps/geojson/?table=aeropuerto&schema_city=",
    zindex: 1,
    type: "single",
    popup: {
        default: {
            content: {
                es: {
                    name: "Nombre del aeropuerto: ",
                },
            },
            separators: {
                decimal: [],
                thousand: [],
            },
        },
    },
    titleSideBar: "Mobility Indicators Content.layers.Aeropuerto",
    style: {
        regular: false,
        fillColor: "rgb(142, 28, 55)",
        strokeColor: "rgb(35, 35, 35)",
        strokeWidth: 0.7,
        strokeLineDash: [],
        points: 0,
        radius: 0,
        angle: 0,
        rotation: 0,
    },
    legend: {
        default: {
            title: "Mobility Indicators Content.layersLegend.Aeropuerto.title",
            subtitle: "",
            attribute: "",
            symbol: "rectangle",
            legendCustomCssClass: "map-legend-symbol-border-1px-gray-35-35-35",
            class: [
                {
                    fillColor: "rgb(142, 28, 55)",
                    strokeColor: "rgb(35, 35, 35)",
                    strokeWidth: 0,
                    label: "Mobility Indicators Content.layersLegend.Aeropuerto.classes.1",
                },
            ],
        },
    },
};

export default Aeropuerto;
